import React, { useState, useEffect } from 'react'
import { Checkbox } from 'tea-component'

import NoData from './NoSearchData'
import Item from './Item'
import * as styles from './markets.module.less'
import { MarketsProps, ItemProps } from '../type'
import { getLocaleText } from '@/pages/home/components/RegionSelect/locale'

const Markets = (props: MarketsProps) => {
  const {
    searchValue,
    activeItem,
    title,
    showChinese,
    marketsSelectListOnChange,
    svgSrc,
    unidentifiedNoDataText
  } = props
  const [renderList, setRenderList] = useState(activeItem?.children || [])
  const [isAllChecked, setIsAllChecked] = useState(false)
  const hasData = renderList?.length > 0

  // 全体操作
  const operationAll = (isAllChecked: boolean) => {
    if (isAllChecked) {
      marketsSelectListOnChange([], activeItem.id)
    } else {
      const allMarkets = renderList?.map((region: any) => region?.id)
      marketsSelectListOnChange(allMarkets, activeItem.id)
    }
    setIsAllChecked(!isAllChecked)
  }

  // 筛选
  const renderListFilter = () => {
    let newRenderList: any = activeItem?.children || []
    if (searchValue) {
      newRenderList = activeItem?.children?.filter((market: any) => {
        return market?.name?.toLowerCase()?.includes(searchValue?.toLowerCase()) || market?.cnname?.includes(searchValue)
      })
    }
    return newRenderList
  }

  useEffect(() => {
    setRenderList(renderListFilter())
    setIsAllChecked(Boolean(activeItem?.childrenSelectList?.length))
  }, [JSON.stringify(activeItem)])

  useEffect(() => {
    setRenderList(renderListFilter())
  }, [searchValue])

  return (
    <div className={styles['markets-container']}>
      <div className={styles.title}>
        <span>{title[1]}</span>
        {
          hasData && (
            <span
              className={styles['operation-btn']}
              onClick={() => operationAll(isAllChecked)}
            >
              {
                isAllChecked && getLocaleText('clear_all') || getLocaleText('select_all')
              }
            </span>
          )
        }
      </div>
      {
        <div className={styles.list}>
          {
            hasData && (
              <Checkbox.Group
                className={styles.tea}
                value={activeItem?.childrenSelectList || []}
                onChange={(value: any[]) => marketsSelectListOnChange(value, activeItem.id)}
              >
                {
                  renderList?.map((item: ItemProps) => (
                    <Item showChinese={showChinese} market={true} key={item.id} {...item} svgSrc={svgSrc} />
                  ))
                }
              </Checkbox.Group>
            ) || (
              <NoData text={activeItem?.noDataText ? activeItem?.noDataText : !searchValue ? unidentifiedNoDataText : getLocaleText('no_data')} />
            )
          }
        </div>
      }
    </div>
  )
}

export default Markets